<template>
  <div></div>
</template>

<script>
  import * as turf from '@turf/turf'

  export default {
    name: 'map-polygon',

    props: {
      google: Object,
      map: Object,
      path: Array,
    },

    activated() {
      this.polygon = new this.google.maps.Polygon({
        path: this.path.map(points => {
          return { lng: points[0], lat: points[1] }
        }),
        map: this.map,
        strokeColor: '#10b8a8',
        strokeOpacity: 1,
        fillColor: '#10b8a8',
        fillOpacity: 0.5
      })
    },

    deactivated() {
      this.polygon.setMap(null)
    }
  }
</script>

<style lang="scss" scoped>
div {
  opacity: 0;
  width: 0;
  height: 0;
}
</style>
